import React from 'react'
import { Table, Th, Td, Tr, Badge } from '@/shared/ui'
import { listBankAccountsOf, type BankAccount } from '@/modules/affiliates/services/affiliateBankService'

export default function AffiliateBankAccountsPanel({ affiliateUserId }: { affiliateUserId: string }) {
  const [rows, setRows] = React.useState<BankAccount[]>([])
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string|null>(null)
  React.useEffect(()=>{ (async()=>{ setLoading(true); setError(null); try { setRows(await listBankAccountsOf(affiliateUserId)) } catch(e:any){ setError(e?.message||'Falha ao carregar dados bancários') } finally { setLoading(false) } })() }, [affiliateUserId])
  return (
    <div className="mt-8">
      <div className="mb-3 text-base font-medium">Dados bancários do afiliado</div>
      {error && <div className="mb-3 rounded-md border border-destructive/30 bg-destructive/10 p-2 text-sm text-destructive-foreground">{error}</div>}
      {loading ? <div className="text-sm text-foreground/70">Carregando...</div> : (
        <Table>
          <thead><Tr><Th>Método</Th><Th>Titular</Th><Th>Documento</Th><Th>Chave/Conta</Th><Th>Padrão</Th></Tr></thead>
          <tbody>
            {rows.map(r => (
              <Tr key={r.id}>
                <Td>{r.method?.toUpperCase()}</Td>
                <Td>{r.holder_name}</Td>
                <Td>{r.document || '—'}</Td>
                <Td>{r.method==='pix' ? (r.pix_key_value || '—') : `${r.bank_code || ''} ${r.branch || ''} ${r.account_number || ''}`}</Td>
                <Td>{r.is_default ? <Badge variant="soft" color="success">Padrão</Badge> : '—'}</Td>
              </Tr>
            ))}
            {rows.length===0 && (<Tr><Td colSpan={5} className="py-6 text-center text-sm text-foreground/70">Sem dados bancários.</Td></Tr>)}
          </tbody>
        </Table>
      )}
    </div>
  )
}

